import { render, staticRenderFns } from "./PartnerIndex.vue?vue&type=template&id=28a5dd65&scoped=true"
import script from "./PartnerIndex.vue?vue&type=script&lang=js"
export * from "./PartnerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5dd65",
  null
  
)

export default component.exports